// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 微信授权code换取登陆业务系统token POST /api/getJSSDKSignature */
export async function getjsapiSignature(
  params: {
    url?: string;
    type?: string;
  },
  options?: { [key: string]: any },
) {
  return request('/api/getJSSDKSignature', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

